import { fromJS } from 'immutable';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SET_OPT_IN_STATUS,
  SET_OPT_IN_STATUS_SUCCESS,
  SET_OPT_IN_STATUS_FAILED,
} from './types';

export const initialState = fromJS({
  loading: false,
  error: false,
  setOptInStatusLoading: false,
  setOptInStatusError: false,
});

export default (
  state = initialState,
  action: { type: string; id?: string; value?: boolean; error?: Error }
) => {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    case SET_OPT_IN_STATUS:
      return state.set('setOptInStatusLoading', true);

    case SET_OPT_IN_STATUS_SUCCESS:
      return state.set('setOptInStatusLoading', false);

    case SET_OPT_IN_STATUS_FAILED:
      return state.set('setOptInStatusError', action.error).set('setOptInStatusLoading', false);

    default:
      return state;
  }
};
